// extracted by mini-css-extract-plugin
export default {"container":"styles_container__AkRUL","title":"styles_title__FYe5J","subTitle":"styles_subTitle__MPpKY"};